export var unsubscribeAllEvents = function (provider) {
    var collabEvents = [
        'init',
        'connected',
        'data',
        'presence',
        'telepointer',
        'local-steps',
        'error',
    ];
    collabEvents.forEach(function (evt) {
        provider.unsubscribeAll(evt);
    });
};
//# sourceMappingURL=unsubscribe.js.map